
import { StationModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, Ref, VModel, Vue, Watch } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import { stationsStore } from '@/libs/stations/+state/store';

@Component({})
export default class StationSelect extends Vue {
    @VModel() innerValue!: string;
    @Prop({ default: '' }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: false }) showWorkplace!: boolean;
    @Prop({ default: null }) workplaceId!: string | string[] | null;
    @Prop({ default: () => [] }) filter!: string[];
    @Prop() placeholder!: string;
    @Prop() attach!: string;

    @Ref() autocomplete!: Autocomplete;

    get items(): StationModel[] {
        let items = [...(stationsStore.useGetter(CrudGetter.Data) as StationModel[])];
        if (this.workplaceId) {
            if (Array.isArray(this.workplaceId)) {
                items = items.filter((x) => this.workplaceId?.contains(x.workplaceId!) == true);
            } else if (this.workplaceId.length > 0) {
                items = items.filter((x) => x.workplaceId === this.workplaceId);
            }
        }
        if (this.filter?.length > 0 && items.some((x) => this.filter.contains(x.id!))) {
            items = items.filter((x) => this.filter.contains(x.id!));
        }
        return items.sort((a: StationModel, b: StationModel) => {
            if (a.name! < b.name!) {
                return -1;
            }
            if (a.name! > b.name!) {
                return 1;
            }
            return 0;
        });
    }

    getName(e: StationModel) {
        if (e.workplace && this.showWorkplace) {
            return `${e.name} (${e.workplace.name})`;
        }
        return e.name;
    }
}
